import React, { useContext, useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import Modal from '../../../UI/Modal/Modal';
import Remove from '../../../../assets/Icon/Remove';
import tbl from '../../../../assets/Style/Table.module.css';
import paycl from '../TransactionModal/TransactionModal.module.css';
import css from './AgentCRMModal.module.css';
import { selectStyle } from '../TransactionModal/selectStyle';
import { baseFileURL } from '../../../../Api';
import { AppContext } from '../../../../providers/appProvider';
import { useAgentCRM } from '../../../../hooks/useAgentCRM';
import { useAgentCRMCarFile } from '../../../../hooks/useAgentCRMCarFile';

const AgentCRMModal = ({ car }) => {
    const { app } = useContext(AppContext);
    const { agentCRMService } = useAgentCRM(1000);
    const { agentCRMCarFileService } = useAgentCRMCarFile();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [items, setItems] = useState(car.agentcrm_car_files || []);
    const [isLoaded, setIsLoaded] = useState(Boolean(car.agentcrm_car_files));
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [file, setFile] = useState(null);
    const [error, setError] = useState("");
    const [fileInputKey, setFileInputKey] = useState(1);

    useEffect(() => {
        setItems(car.agentcrm_car_files || []);
        setIsLoaded(Boolean(car.agentcrm_car_files));
    }, [car.agentcrm_car_files]);

    const formatDate = (dateString) => {
        if (!dateString) {
            return "";
        }

        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return "";
        }

        return date.toLocaleDateString("ka-GE");
    };

    const loadItems = async () => {
        const list = await agentCRMCarFileService.fetchList(car.id);
        setItems(list);
        setIsLoaded(true);
    };

    const openModal = async () => {
        setIsModalOpen(true);
        setError("");
        loadItems();
        if (app.hasPermission("CAR_AGENT_ADD")) {
            agentCRMService.fetchList();
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const agentOptions = useMemo(() => {
        return agentCRMService.items.map((agent) => ({
            value: agent.id,
            label: agent.name,
        }));
    }, [agentCRMService.items]);

    const onAdd = async () => {
        if (!selectedAgent || !file) {
            setError("აირჩიე აგენტი ცრმ და ფაილი");
            return;
        }

        await agentCRMCarFileService.add({
            agent_id: selectedAgent.value,
            car_id: car.id,
            file_upload: file,
        });

        setSelectedAgent(null);
        setFile(null);
        setFileInputKey((key) => key + 1);
        setError("");
        loadItems();
    };

    const onRemove = async (id) => {
        await agentCRMCarFileService.remove(id);
        loadItems();
    };

    const label = items.length > 0 ? (items[0].agentcrm?.name || "- - -") : "- - -";
    const labelClassName = items.length > 0 ? css.trigger : css.trigger + ' ' + css.empty;

    return (
        <div onClick={(event) => event.stopPropagation()}>
            <span className={labelClassName} onClick={openModal}>
                {label}
            </span>

            <Modal isOpen={isModalOpen} size="medium" onClose={closeModal}>
                <div className={paycl.modalHead}>
                    <h3>აგენტები</h3>
                </div>

                <div>
                    <div className={tbl.table + ' ' + paycl.table} style={{ minHeight: '50px' }}>
                        <table>
                            <thead>
                                <tr>
                                    <th className={paycl.id}>#</th>
                                    <th>აგენტი ცრმ</th>
                                    <th>ასატვირთი ფაილი</th>
                                    <th>შექმნის თარიღი</th>
                                    <th className={paycl.btntbl}> </th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoaded && items.length === 0 && (
                                    <tr>
                                        <td colSpan="5">- - -</td>
                                    </tr>
                                )}

                                {items.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className={paycl.id}>{index + 1}</td>
                                        <td>{item.agentcrm?.name || "- - -"}</td>
                                        <td>
                                            {item.file && (
                                                <a className={css.fileLink} href={baseFileURL + item.file} target="_blank" rel="noopener noreferrer">
                                                    ფაილი
                                                </a>
                                            )}
                                        </td>
                                        <td>{formatDate(item.created_at)}</td>
                                        <td className={paycl.btntbl}>
                                            {app.hasPermission("CAR_AGENT_DELETE") && (
                                                <div className={paycl.btns}>
                                                    <span className={paycl.removeBtn} onClick={() => onRemove(item.id)}>
                                                        <Remove /> წაშლა
                                                    </span>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {app.hasPermission("CAR_AGENT_ADD") && (
                        <div className={paycl.formField}>
                            <legend>აგენტის დამატება</legend>

                            {error && <div className={css.error}>{error}</div>}

                            <div className={paycl.row}>
                                <div style={{ width: '100%' }}>
                                    <Select
                                        styles={selectStyle}
                                        options={agentOptions}
                                        value={selectedAgent}
                                        onChange={setSelectedAgent}
                                        placeholder="აირჩიე აგენტი ცრმ"
                                        isClearable
                                    />
                                </div>

                                <div style={{ width: '100%' }}>
                                    <div className={paycl.uploadDiv}>
                                        <input
                                            key={fileInputKey}
                                            type="file"
                                            name="file"
                                            accept=".pdf,.doc,.docx,image/*"
                                            onChange={(event) => setFile(event.target.files[0])}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={paycl.addBox}>
                                <span onClick={onAdd} className={paycl.addBtn}>დამატება</span>
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default AgentCRMModal;
